import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import { absoluteAssetUrl, CANONICAL_ORIGIN } from "@/lib/seo";
import { PageSkeleton } from "@/components/LoadingSkeleton";

export default function BlogList() {
  const [articles, setArticles] = useState(null);
  useEffect(() => { api.get("/blog").then((r) => setArticles(r.data || [])).catch(() => setArticles([])); }, []);
  const schema = {
    "@context": "https://schema.org", "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Forside", item: `${CANONICAL_ORIGIN}/` },
      { "@type": "ListItem", position: 2, name: "Viden", item: `${CANONICAL_ORIGIN}/blog` },
    ],
  };
  return <>
    <Seo title="Viden og inspiration | SpørgMig" description="Viden og inspiration om IT, markedsføring og iværksætteri. Bliv klogere på problemet og se, hvornår personlig hjælp giver mening." path="/blog" schemas={schema}/>
    <main className="mx-auto max-w-6xl px-4 py-10 sm:px-8 sm:py-14" data-testid="blog-list">
      <p className="font-mono text-xs uppercase tracking-widest text-brand-fresh">Viden fra SpørgMig</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl">Viden og inspiration</h1>
      <p className="mt-3 max-w-2xl text-sm leading-6 text-brand-body">Bliv klogere på almindelige udfordringer inden for IT, markedsføring og iværksætteri. Har du brug for hjælp til din konkrete situation, kan du beskrive problemet og få et personligt tilbud.</p>
      {articles === null ? <PageSkeleton cards={3}/> : <div className="mt-9 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => <article key={article.id} className="card-outline overflow-hidden bg-white">
          {article.cover_image_url && <img src={absoluteAssetUrl(article.cover_image_url)} alt={`Forsidebillede til ${article.title}`} loading="lazy" className="aspect-[16/9] w-full object-cover"/>}
          <div className="p-5">
            <div className="text-xs text-brand-muted">{article.published_at ? new Date(article.published_at).toLocaleDateString("da-DK", { day: "numeric", month: "long", year: "numeric" }) : ""}{article.category?.name ? ` · ${article.category.name}` : ""}</div>
            <h2 className="mt-2 text-xl font-semibold leading-snug text-brand-ink"><Link to={`/blog/${article.slug}`} className="hover:text-brand-fresh">{article.title}</Link></h2>
            <p className="mt-2 line-clamp-3 text-sm leading-6 text-brand-body">{article.excerpt}</p>
            <Link to={`/blog/${article.slug}`} className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-brand-fresh">Læs mere <ArrowRight size={15}/></Link>
          </div>
        </article>)}
        {articles.length === 0 && <div className="col-span-full rounded-xl border border-dashed border-brand-line p-10 text-center text-sm text-brand-muted">Der er ikke publiceret artikler endnu.</div>}
      </div>}
    </main>
  </>;
}


